import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { LicenceBadge, SponsoredTag, Stars } from "@/components/shared";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

const FALLBACK = "https://images.pexels.com/photos/8961034/pexels-photo-8961034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600";

export const CompanyCard = ({ company, compact = false }) => {
  const trackClick = () => {
    if (company.promoted && company.promotion_id) {
      api.post(`/promotions/${company.promotion_id}/event?type=profile_click`).catch(() => {});
    }
  };
  return (
  <div className="bg-white rounded-2xl border border-[#E3E8E8] overflow-hidden card-lift flex" data-testid={`company-card-${company.slug}`}>
    {!compact && (
      <div className="w-32 sm:w-40 shrink-0 bg-white border-r border-[#E3E8E8] flex items-center justify-center p-3">
        <img src={company.logo || FALLBACK} alt={company.trading_name} className="max-w-full max-h-full object-contain" loading="lazy" />
      </div>
    )}
    <div className="flex-1 p-5 min-w-0">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <h3 className="font-display font-bold text-lg text-[#0B1733] truncate">{company.trading_name}</h3>
          <p className="text-sm text-[#4A5568] truncate">{company.services?.length ? company.services.join(" · ") : company.service_slugs?.join(" · ")}</p>
        </div>
        {company.promoted && <SponsoredTag />}
      </div>
      <div className="mt-2 flex items-center gap-3 text-xs text-[#4A5568]">
        <span className="inline-flex items-center gap-1"><MapPin size={13} /> {company.emirate}</span>
        <Stars value={company.rating} />
      </div>
      <div className="mt-3 flex items-center justify-between gap-2">
        {company.licence_checked ? <LicenceBadge date={company.licence_check_date} /> : <span className="text-xs text-[#4A5568]">Licence not yet checked</span>}
        <Link to={`/companies/${company.slug}`} onClick={trackClick} data-testid={`view-profile-${company.slug}`}>
          <Button variant="outline" size="sm" className="rounded-full border-[#E3E8E8] text-[#0B1733] hover:bg-[#E8F5F1] hover:text-[#007F83]">View profile</Button>
        </Link>
      </div>
    </div>
  </div>
  );
};
